import { GET_ZONA_DETALLE, MODIFY_FIELD_DETALLE_ZONA, UPDATE_ZONA_DE_UN_CENTRO } from '../constants/action_types';

const initialState = { zona: {}, updated: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_ZONA_DETALLE + "_SUCCESS":

            return {
                zona: {
                    id: action.payload.data.id,
                    centroId: action.payload.data.centroId,
                    iTipoZona: action.payload.data.iTipoZona,
                    descr: action.payload.data.descr,
                    activo: action.payload.data.activo,
                    tipoZona: action.payload.data.tipoZona,
                    iCajaDestino: action.payload.data.iCajaDestino,
                    elemCajaId: action.payload.data.elemCajaId,
                    elemNoCajaId: action.payload.data.elemNoCajaId
                },
                updated: false
            }

        case MODIFY_FIELD_DETALLE_ZONA:
            const field = action.payload[0],
                value = action.payload[1];

            return {
                zona: { ...state.zona, [field]: value },
                updated: false
            };

        case UPDATE_ZONA_DE_UN_CENTRO + "_SUCCESS":

            return {
                // zona: {
                //     id: action.payload.data.id,
                //     centroId: action.payload.data.centroId,
                //     iTipoZona: action.payload.data.iTipoZona,
                //     descr: action.payload.data.descr,
                //     activo: action.payload.data.activo,
                //     tipoZona: action.payload.data.tipoZona,
                //     iCajaDestino: action.payload.data.iCajaDestino,
                //     elemCajaId: action.payload.data.elemCajaId,
                //     elemNoCajaId: action.payload.data.elemNoCajaId
                // },
                // updated: true

                ...state,
                updated: true

            }

        default:

            return state;
    }

}